import { Component, Input, OnChanges } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SanitizeService } from '@g99-product-web-ui/shared-service';

@Component({
  selector: 'lib-g99-message-box',
  templateUrl: './message-box.component.html',
  styleUrl: './message-box.component.scss',
  standalone: false,
})
export class MessageBoxComponent implements OnChanges {
  @Input() public message = '';
  @Input() public messageColor = '#fff';
  @Input() public icon = '';
  @Input() public backgroundColor = '#FFF3F0';
  @Input() public iconColor = '';
  @Input() public iconFontSize = '12px';

  public safeSvgIcon!: SafeHtml;

  constructor(private readonly _sanitizeService: SanitizeService) {}

  ngOnChanges(): void {
    if (this.icon) {
      this.safeSvgIcon = this._updateIconColor(this.icon, this.iconColor);
    }
  }

  /**
   * Updates the SVG icon's fill color if a valid color is provided.
   * @param icon - The SVG icon string
   * @param color - The color to be applied to the icon
   * @returns - The updated icon string with the applied color
   */
  private _updateIconColor(icon: string, color: string): SafeHtml {
    const updatedIcon = color ? this._applyIconColor(icon, color) : icon;
    return this._sanitizeService.sanitizeContent(updatedIcon);
  }

  /**
   * Replaces the fill color of an SVG icon with the provided color.
   * @param icon - The SVG icon string
   * @param color - The color to be applied to the SVG fill
   * @returns - The updated SVG icon with the new fill color
   */
  private _applyIconColor(icon: string, color: string): string {
    return icon.replace(/fill="[^"]*"/g, `fill="${color}"`);
  }
}
